/**
 * @deprecated
 */

/**
 * @deprecated
 */
export function formatRelative(intlShape, ...[value, unit, formatOptions]) {
  return intlShape.formatRelativeTime(value, unit, formatOptions);
}